import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "excludeUsedFilter",
    pure: false
})
export class ExcludeUsedFilterPipe implements PipeTransform {
    transform(items: any[], filter: any, filter2: any): any[] {
        if (!items || filter === undefined || filter === null) {
            return items;
        }
        // filter items array, items which match and return true will be kept, false will be filtered out
        return items.filter((item: any) => this.applyFilter(item, filter, filter2));
    }
  
    applyFilter(item: any, filter: any, filter2: any): boolean {
        if (item.id === -1)
            return true;

        return (item.id !== filter) && (item.id !== filter2);
    }
}